import { useCallback, useState } from "react";

export interface PoiPopupState {
    "visible": boolean;
    "lngLat":  [number, number];
    "name":    string;
    "type":    string;
    "x":       number;
    "y":       number;
}

const INITIAL_POI_POPUP_STATE: PoiPopupState = {
    "visible": false,
    "lngLat":  [ 0, 0 ],
    "name":    "",
    "type":    "",
    "x":       0,
    "y":       0,
};

interface UsePoiPopupResult {
    "poiPopupProps": PoiPopupState & { "onClose": () => void };
    "poiPopupKey":   number;
    "openPoiPopup":  ( x: number, y: number, lat: number, lon: number, name: string ) => void;
}

export function usePoiPopup(): UsePoiPopupResult {
    const [ poiPopup, setPoiPopup ]       = useState<PoiPopupState>( INITIAL_POI_POPUP_STATE );
    const [ poiPopupKey, setPoiPopupKey ] = useState( 0 );

    const openPoiPopup = useCallback( (
        x: number,
        y: number,
        lat: number,
        lon: number,
        name: string,
    ): void => {
        setPoiPopup( {
            "visible": true,
            "lngLat":  [ lon, lat ],
            "name":    name,
            "type":    "",
            "x":       x,
            "y":       y,
        } );
        setPoiPopupKey( ( prev ) => prev + 1 );
    }, [] );

    const closePoiPopup = useCallback( (): void => {
        setPoiPopup( ( previousState ) => ( {
            ...previousState,
            "visible": false,
        } ) );
    }, [] );

    return {
        "poiPopupProps": {
            ...poiPopup,
            "onClose": closePoiPopup,
        },
        poiPopupKey,
        openPoiPopup,
    };
}
